import totalQuiz from '../../../assets/icons/TotalAssessmentIcon.svg';
import timeTaken from "../../../assets/icons/TotalTimeTakenIcon.svg";
import uniqueIcon from '../../../assets/icons/uiqueQuesIcon.svg';
import QuizCalender from './charts/QuizCalender';
import CourseWiseChart from './charts/CourseWiseChart';
import QuizStatCard from './QuizStatCard';
import QuizService from '../../../services/QuizService';
import { useCallback, useContext, useEffect, useState } from 'react';
import AuthContext from '../../../auth/AuthContext';
import AlertService from '../../../services/AlertService';

const QuizDashboard = () => {
  const authContext = useContext(AuthContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true);

  const quizAccess = authContext.getPermissions("quizdashboard");
  const showAdd = quizAccess.some(f => f.access.includes(3));

 const loadDashboard = useCallback(async (signal) => {
    setLoading(true);
    try {
      const data = await QuizService.GetDashboard(
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        let baseCards = [
          { title: "Total Quizzes", value: data.data.totalQuiz, icon: totalQuiz, bgColor: "#EBF1F3" },
          { title: "Unique Questions", value: data.data.mcqQuestions, icon: uniqueIcon, bgColor: "#DCF6E0" },
        ];

        if (showAdd) {
          baseCards.push(
            { title: "Overall Time Taken", value: data.data.totalHours, valueSuffix: "Hours", icon: timeTaken, bgColor: "#F6EED9" },
            { title: "Total Users", value: data.data.totalUsers, icon: timeTaken, bgColor: "#E3CFCF" }
          );
        }

        setCardData(baseCards);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; // 👈
      AlertService.error("Failed to load dashboard data");
      console.error(err);
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext, showAdd]);

useEffect(() => {
    const controller = new AbortController();
    loadDashboard(controller.signal); 
    return () => controller.abort();
  }, [loadDashboard]);

  return (
    <div className="container-fluid mt-3 pt-3 pb-3">
      {/* Stats Cards */}
      <div className="row g-3">
        {(loading ? Array.from({ length: showAdd ? 4 : 2 }) : cardData).map((card, idx) => (
          <div key={idx} className="col-md-6 col-xl-3">
            <QuizStatCard {...card} loading={loading} />
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="row g-3 align-items-stretch mt-2">
        <div className="col-xl-4 col-lg-6 col-md-12">
          <div className="h-100">
            <QuizCalender />
          </div>
        </div>
        <div className="col-xl-4 col-lg-6 col-md-12">
          <div className="h-100">
            <CourseWiseChart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizDashboard;
